/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = {
  target: 'webpack',
  isBrowser: true
};




//////////////////
// WEBPACK FOOTER
// ./~/targetenv/lib/index-webpack.js
// module id = 3
// module chunks = 49